import { lazy } from 'react';

import type { RouteConfig } from '../../types';

const DashboardLayout = lazy(() => import('@/layouts/DashboardLayout'));
const StatesLayout = lazy(() => import('@/pages/states/layout'));
const StatesListPage = lazy(() => import('@/pages/states'));
const StateDetailPage = lazy(() => import('@/pages/states/detail'));

/**
 * State entity routes: the states grid and a state's detail page, where the
 * state is assigned to a market. `StatesLayout` mounts the section
 * breadcrumb. Permissions: `@/config/auth/routeAccess`.
 */
export const stateRoutes: RouteConfig = {
  path: '/states',
  layout: DashboardLayout,
  children: [
    {
      path: '',
      layout: StatesLayout,
      children: [
        { path: '', element: StatesListPage },
        { path: '/:stateCode', element: StateDetailPage },
      ],
    },
  ],
};
